import { SignOffGeneratedEntity } from "./generated/SignOffGeneratedEntity";

export abstract class SignOffEntity extends SignOffGeneratedEntity {
    // Comment to preserve new line
}
